import {RecentFiltersSectionConfig} from 'filters/features/FilterDialog/types';

import {useEditedFilterContext} from 'filters/features/FilterDialog/contexts/internal/EditedFilterProvider/EditedFilterProvider';
import {useFilterActionsContext} from 'filters/contexts/FilterActionsProvider/FilterActionsProvider';

import {PrimaryActionButton} from 'modules/decisionsNext/components/DecisionsDialog';

export const RecentFiltersPrimaryAction = ({recentId}: Omit<RecentFiltersSectionConfig, 'footer'>) => {
  const {setFilter} = useEditedFilterContext();
  const {useStoredFilters} = useFilterActionsContext();
  const {recentFilters} = useStoredFilters();

  return (
    <PrimaryActionButton
      type='submit'
      disabled={!recentId}
      onClick={() => {
        const filter = recentFilters?.find(f => f.id === recentId)?.filter;

        if (!filter) {
          throw new Error(`No filter found ${recentId}`);
        }

        setFilter(filter);
      }}
    >
      Apply filters
    </PrimaryActionButton>
  );
};
